<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <luca-day-code-create-or-update v-model="data"></luca-day-code-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import LucaDayCodeCreateOrUpdate from './components/LucaDayCodeCreateOrUpdate.vue';

export default{
    components:{
        BCard,
        LucaDayCodeCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:'Çalışma Gün Türü',key:'EmployeeWorkingTypeName',thClass:'w-33'},
                {name:'Çalışma Gün Türü Kodu',key:'EmployeeWorkingTypeCode',thClass:'w-34'},
                {name:'Luca Karşılığı',key:'LucaCode',thClass:'w-33'}
            ],
            data:{
                Id:null,
                EmployeeWorkingTypeId:null,
                EmployeeWorkingTypeCode:null,
                LucaCode:null
            },
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"primary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete, condition:(i) => i.Id},
            ],
            editing:false,
            loading:false
        }
    },
    methods:{
        provider(){
            return EmployeeOperationsApi.LucaCode.List()
        },
        clearForm(){
            this.editing = false
            this.data.Id = null
            this.data.EmployeeWorkingTypeId = null
            this.data.EmployeeWorkingTypeCode = null
            this.data.EmployeeWorkingTypeName = null
            this.data.LucaCode = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.data.Id = item.Id
            this.data.EmployeeWorkingTypeId = item.EmployeeWorkingTypeId
            this.data.EmployeeWorkingTypeCode = item.EmployeeWorkingTypeCode
            this.data.EmployeeWorkingTypeName = item.EmployeeWorkingTypeName
            this.data.LucaCode = item.LucaCode
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.LucaCode.Create(this.data.EmployeeWorkingTypeId,this.data.LucaCode)
            .then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
                this.loading = false
                this.$hideModal('create-or-update')
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem (${item.EmployeeWorkingTypeCode}) ile (${item.LucaCode}) eşleşmesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.LucaCode.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    },

}
</script>